export const user = {
    'creation-date': 'Data e krijimit',
    add: 'Shto përdorues',
    edit: 'Redakto përdoruesin',
    assignment: 'Detyra | Detyrat',
    'add-assignment': 'Shto Detyrë',
    'blocked-stores': 'Dyqane të bllokuara'
  };
  